import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { KeyboardLike, KeyWith } from '@/lib/piano/keyboard';
import { computeKeyboardPlacement } from '@/lib/piano/keyboard/keyboard-geometry';
import { useHoveredKey, type HoveredKeyApi } from './use-hovered-key';

/**
 * The geometry a chart and its keyboard axis share, plus the key being read.
 *
 * One white key is one unit, so the chart's x axis and the keyboard drawn
 * under it use the same numbers and line up at any width.
 */
export const useChartFigure = (keyboard, t0) => {
  const $ = _c(8);
  const gridCount = t0 === undefined ? 1 : t0;
  let t1;
  if ($[0] !== keyboard) {
    t1 = keyboard.getKeys();
    $[0] = keyboard;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const keys = t1;
  let t2;
  if ($[2] !== keys) {
    t2 = computeKeyboardPlacement(keys);
    $[2] = keys;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const geometry = t2;
  const hover = useHoveredKey(geometry, keyboard.size, gridCount);
  let t3;
  if ($[4] !== geometry || $[5] !== hover || $[6] !== keys) {
    t3 = {
      geometry,
      hover,
      keys
    };
    $[4] = geometry;
    $[5] = hover;
    $[6] = keys;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};